export const subcategoriesState = (state) => state.subcategories;

export const getLoadingSubcategories = (state) => subcategoriesState(state).loading;

export const getResponseSubcategories = (state) =>
  subcategoriesState(state).response;
